import React from 'react';
import { enumValue, getGapTypeBySection, isInRolledUpStatus } from '~/util';
import { NavTabs } from '~/components/Patient/NavTabs';
import { ServicesContext } from '~/services';

interface GapTypeTabsProps {
    patient: PatientType;
    page: string;
    setPage: (x: string) => void;
}
export function GapTypeTabs({ patient, page, setPage }: GapTypeTabsProps) {
    const context = React.useContext(ServicesContext);

    function getCount(type: 'risk_gaps' | 'quality_gaps' | 'foc_gaps') {
        const gapType = getGapTypeBySection(type);

        return `(${
            (patient[type] as GapType[]).filter(
                (x) =>
                    isInRolledUpStatus(
                        gapType,
                        enumValue(['gap', 'status', 'Pending']),
                        x.status
                    ) && !x.is_added
            ).length
        })`;
    }

    const tabs = [
        { label: `Attestation ${getCount('risk_gaps')}`, val: 'risk_gaps' },
        { label: `AgeWise ${getCount('foc_gaps')}`, val: 'foc_gaps' },
        { label: `Quality ${getCount('quality_gaps')}`, val: 'quality_gaps' },
    ];
    if (context.user.hasFeatureToggle('hidden_foc')) {
        tabs.splice(1, 1);
    }
    if (context.user.hasFeatureToggle('referrals')) {
        tabs.push({
            label: context.user.hasFeatureToggle('outgoing_referrals')
                ? 'Send Referrals'
                : 'Referrals',
            val: 'referrals',
        });
    }
    if (
        context.user.hasFeatureToggle('outgoing_referrals') &&
        context.user.getExternalAccount('Core App')
    ) {
        tabs.push({ label: 'Outgoing Referrals', val: 'outgoing_referrals' });
    }
    return <NavTabs tabs={tabs} page={page} setPage={setPage} />;
}
